<template>
  <div class="content-wrappper">
    <div
      class="col-md-12 menu-header"
      v-bind:class="{ 'disable-content': disableContent || importProgressStatus }"
    >
      <div
        class="col-xs-12 p-0 d-flex header-container align-items-center justify-space-between xs-flex-column"
      >
        <div class="page-title d-flex align-items-center col-xs-12 col-sm-6 col-md-7 p-0">
          <img src="/static/images/icons/vector_stoke_left_blue.svg" />Regulatory Watch Admin
        </div>
        <div class="search-container-parent d-flex col-xs-12 col-sm-6 col-md-5 col-gap-20 p-0">
          <div
            class="search-container p-0"
            v-if="permissions.includes('REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_SEARCH')"
            :class="[
              permissions.includes('REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_CREATE_NEW_ALERT')
                ? 'col-xs-10'
                : 'col-xs-12'
            ]"
          >
            <search-box v-model="alertSearch"></search-box>
          </div>
          <button
            @click="addAlertModal"
            class="btn emergo-green-button"
            v-if="
              permissions.includes('REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_CREATE_NEW_ALERT')
            "
          >
            <div class="d-flex align-items-center btn-container">
              <img src="/static/images/icons/add.svg" alt="add-icon" />
              <span class="pl-5 xs-hide">Add Alert</span>
            </div>
          </button>
        </div>
      </div>
      <div class="col-xs-12 d-flex justify-space-between align-items-center p-0 count-section">
        <div class="reg-watch-count font-18 text-secondary mb-0 fw-400" v-if="!alertSearch.length">
          {{ gridData.length }}
          alerts
        </div>
        <div v-else-if="alertSearch.length">
          <div class="reg-watch-count font-18 text-secondary mb-0 fw-400">
            {{ searchResultCount }} result(s) found
          </div>
          <div class="text-secondary font-16">out of {{ gridData.length }} alerts</div>
        </div>
        <button
          v-if="permissions.includes('REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_SELECT/DELETE')"
          class="btn btn-delete font-18 p-0 d-flex align-items-center col-gap-10 fw-400"
          v-on:click="confirmDeleteRegistrations"
          :disabled="selectedAlert.length == 0"
        >
          <i class="fa fa-trash"></i> <span>Delete</span>
        </button>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12" style="padding: 0">
      <alert-data-grid
        :permissions="permissions"
        :disableContent="disableContent || importProgressStatus"
        :refreshDataAfterDelete="refreshDataAfterDelete"
        :loadingStatus="loaderStatus"
        :data="gridData"
        :filter-key="alertSearch"
        :selectedAlertList="selectedAlert"
        :clearSelection="clearSelection"
        @selectedAlertListChanged="selectedAlertListChanged"
        @searchResult="SetSearchResult"
        @setSearch="setSearch"
        @regulatoryAlertClicked="regulatoryAlertClicked"
      ></alert-data-grid>
    </div>

    <alert-popup
      :regulatoryAlertData="selectedRegulatoryAlert"
      :newRegulatoryAlert="newRegulatoryAlertFlag"
      :reviewAlertFlag="reviewAlertFlag"
      :editRegulatoryAlert="editRegulatoryAlertFlag"
    ></alert-popup>

    <loader :loadingStatus="loaderStatus"></loader>
    <delete-alert-popup
      :selectedAlerts="selectedAlert"
      @loadRegistrationData="loadAlertDataAfterDelete"
    ></delete-alert-popup>
    <import-progress-bar
      :mode="mode"
      :progressStatus="importProgressStatus"
      :percentage="importPercentage"
      @updateImportProgressStatus="updateImportProgressStatus"
    ></import-progress-bar>
  </div>
</template>
<script>
import moment from 'moment';
import $ from 'jquery';
import DeleteAlertPopup from './DeleteAlert.vue';
import Loader from '../UIComponents/Loader.vue';
import AlertPopup from './AlertPopup.vue';
import AlertDataGrid from './AlertDataGrid.vue';
import EventBus from '../../utils/event-bus';
import ImportProgressBar from '../UIComponents/ImportProgressBar.vue';
import SearchBox from '../UIComponents/SearchBox.vue';
import { getAllRegulatoryAlerts } from '../../apis/regulatoryUpdate';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';

export default {
  mixins: [permissionsList],
  components: {
    AlertDataGrid,
    DeleteAlertPopup,
    Loader,
    AlertPopup,
    ImportProgressBar,
    SearchBox
  },
  props: {
    roleId: Number
  },
  data() {
    return {
      permissions: [],
      mode: 'alerts',
      importPercentage: 0,
      importProgressStatus: false,
      loaderStatus: false,
      gridData: [],
      selectedAlert: [],
      alertSearch: '',
      searchResultCount: 0,
      awaitingReviewCount: 0,
      draftCount: 0,
      publishedCount: 0,
      errors: [],
      disableContent: false,
      refreshDataAfterDelete: false,
      modalStart: '',
      selectedRegulatoryAlert: null,
      newRegulatoryAlertFlag: false,
      reviewAlertFlag: false,
      clearSelection: false,
      editRegulatoryAlertFlag: ''
    };
  },
  methods: {
    SetSearchResult(result) {
      this.refreshDataAfterDelete = !this.refreshDataAfterDelete;
      this.searchResultCount = result;
    },

    async validateFeatures() {
      this.loaderStatus = true;
      this.permissions = [];
      const servicesList = ['REGULATORY_WATCH_ADMIN'];
      const modulesList = ['REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      this.loaderStatus = false;
    },
    openCreateAlertPopup(data) {
      this.newRegulatoryAlertFlag = data.newRegulatoryAlertFlag;
      this.reviewAlertFlag = data.reviewAlertFlag;
      this.editRegulatoryAlertFlag = data.editRegulatoryAlertFlag;
      this.selectedRegulatoryAlert = data.selectedRegulatoryAlert;
      $('#createAlertModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    confirmDeleteRegistrations() {
      $('#delete-alert-popup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    updateImportProgressStatus() {
      this.importProgressStatus = false;
      this.importPercentage = 0;
    },
    setSearch(value) {
      this.alertSearch = value;
    },
    async loadAlertDataAfterDelete() {
      $('#delete-alert-popup').modal('hide');
      this.loaderStatus = true;
      await this.loadAlertData();
      this.refreshDataAfterDelete = !this.refreshDataAfterDelete;
      this.loaderStatus = false;
    },
    async loadAlertData() {
      this.importProgressStatus = true;
      const regulatoryAlerts = await getAllRegulatoryAlerts();
      this.gridData = [];
      regulatoryAlerts.forEach((row) => {
        const publishedDate = moment(row.published_date).format('DD MMM, YYYY');
        let alertDate = '';
        if (
          row.status === 'Published' ||
          row.status === 'Awaiting publishing' ||
          row.status === 'Publishing is in progress'
        ) {
          alertDate = publishedDate;
        } else if (row.status === 'draft' || row.status === 'Awaiting review') {
          alertDate = 'Pending';
        }
        this.gridData.push({
          alertId: row.id,
          Status: row.status.charAt(0).toUpperCase() + row.status.slice(1),
          Country: row.country_name,
          Title: row.title,
          'Country Code': row.country_code,
          countryId: row.country_id,
          'Published date': alertDate,
          Description: row.description,
          published_date: row.published_date,
          publishedDate,
          linkList: JSON.parse(row.info_link),
          isPublishAsap: row.is_publish_asap,
          effectiveDate: row.regulatory_effective_date
        });
      });
      this.disableContent = false;
      this.calculateStatusCount();
      this.importProgressStatus = false;
    },
    calculateStatusCount() {
      this.awaitingReviewCount = 0;
      this.draftCount = 0;
      this.gridData.forEach((data) => {
        if (data.Status.match(/awaiting review/i)) {
          this.awaitingReviewCount += 1;
        } else if (data.Status.match(/draft/i)) {
          this.draftCount += 1;
        } else if (data.Status.match(/published/i)) {
          this.publishedCount += 1;
        }
      });
    },

    resetSearch() {
      this.alertSearch = '';
    },

    filterAlert(val) {
      if (val === 1) {
        this.alertSearch = 'awaiting review';
      } else if (val === 2) {
        this.alertSearch = 'draft';
      } else if (val === 3) {
        this.alertSearch = 'published';
      } else {
        this.alertSearch = '';
      }
    },

    selectedAlertListChanged(changedList) {
      this.selectedAlert = changedList;
    },

    regulatoryAlertClicked(selectedRegulatoryAlert) {
      localStorage.setItem(
        `alertItem${selectedRegulatoryAlert.alertId}`,
        JSON.stringify(selectedRegulatoryAlert)
      );
      this.$router.push(
        `/layout/regulatoryUpdatesAdmin/create-alert/${selectedRegulatoryAlert.alertId}`
      );
    },

    addAlertModal() {
      this.$router.push({
        name: 'CreateAlert'
      });
    },

    closeModal() {
      this.clearSelection = true;
    }
  },
  mounted() {
    // this.calculateStatusCount();
    $('#createAlertModal').on('hide.bs.modal', this.closeModal);
    console.log(
      this.reviewAlertFlag,
      this.newRegulatoryAlertFlag,
      this.editRegulatoryAlertFlag,
      this.selectedRegulatoryAlert
    );
  },

  created() {
    this.loadAlertData();
    this.validateFeatures();
    EventBus.$on('loadRegulatoryAlertList', () => {
      this.loadAlertData();
    });

    socket.on(`alertGetRegulatoryAlerts_${localStorage.getItem('userId')}`, (data) => {
      this.importPercentage = data;
    });
    if (this.roleId !== 5 && this.roleId !== 7) {
      this.$router.push('/layout/dashboard');
    }
  },
  beforeDestroy() {
    socket.removeAllListeners(`alertGetRegulatoryAlerts_${localStorage.getItem('userId')}`);
    EventBus.$off('loadRegulatoryAlertList');
  }
};
</script>

<style lang="scss" scoped>
.reg-update-admin {
  text-align: right;
  margin-bottom: 10px;
}
.btn-delete {
  color: $deep-thick-danger !important;
}

.menu-header {
  padding-top: 24px;
  padding-right: 24px;
  padding-left: 24px;
  background-color: $white;
  .header-container {
    margin-bottom: 24px;
    .page-title {
      font-weight: $font-weight-400;
      font-style: $font-weight-normal;
      font-size: $font-24;
      line-height: 28px;
      color: $primary;
      padding-left: 6px;
      margin-top: 0px;
      padding-bottom: 8px;
      img {
        margin-right: 24px;
      }
    }
    .search-container-parent {
      column-gap: 24px;
    }
  }

  .count-section {
    padding-top: 17px;
    padding-bottom: 17px;
    border-bottom: 0.6px solid $gray74;
    border-top: 0.6px solid $gray74;
  }
}

@media only screen and (max-width: 767px) {
  .search-input {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .header-container {
    flex-direction: column;

    .page-title {
      padding-bottom: 0px !important;
      padding-left: 8px !important;
    }
    .search-container-parent {
      margin-top: 24px;
      // margin-bottom: 24px;

      .btn {
        width: 35px;
        display: flex;
        justify-content: center;
        div.btn-container {
          height: 100%;
          span.xs-hide {
            display: none;
          }
        }
      }
    }
  }
}
</style>
